import React from 'react'
import { Helmet } from 'react-helmet-async'

const siteName = 'Yusef Agency'
const siteUrl = 'https://yusef.agency'
const defaultImage = `${siteUrl}/YusefIcon180.png`

function Seo({
  title,
  description,
  path = '/',
  image = defaultImage,
  keywords,
  type = 'website',
  noindex = false,
  structuredData,
}) {
  const canonicalUrl = new URL(path, siteUrl).toString()
  const fullTitle = title ? `${title} | ${siteName}` : siteName
  const robotsContent = noindex ? 'noindex, nofollow' : 'index, follow'
  const structuredDataItems = Array.isArray(structuredData)
    ? structuredData
    : structuredData
      ? [structuredData]
      : []

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsContent} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {structuredDataItems.map((item, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  )
}

export default Seo